/**
 * 导出表格demo
 * @description 导出表格demo
 * @author mll
 * @date 2020-2-3
 */
import React from 'react';
import { connect } from 'dva';

import { component_tool, framework_tool } from '../../../tool'
let { WizLayout, WizInputNumber, WizButton, WizSpin, WizBrowserExport, WizCard, WizNotice } = component_tool;
let { WizContainer } = framework_tool;
const { Content } = WizLayout;

class BrowserExport extends WizContainer {

    componentName = 'BrowserExport';

    state = {
        number: 10,
        spinning: false,
        spinningText: "加载中",
        columnDefs: [
            {
                headerName: '',
                width: 30,
                field: 'rowIndex',
                hidden: true,
                suppressMovable: true,
                cellStyle: {
                    textAlign: 'center',
                    padding: '5px 0',
                    color: '#595959',
                    backgroundColor: '#f0f0f0',
                    display: 'inline-flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    fontWeight: '500',
                    boxShadow: '0 2px 0px 0 rgba(0,0,0,0.15)',
                },
            },
            {
                headerName: '区域',
                field: 'FRUITS_ADMDIV_VALUE',
                width: 15,
                cellStyle: {
                    textAlign: 'center',
                },
                style: {
                    alignment: { vertical: 'bottom', horizontal: 'center' },
                },
                cellRendererFramework: ({ value }) => {
                    if (value) return <a style={{ color: 'green' }}>{value}</a>;
                    return '总计';
                },
            },
            {
                headerName: '奇异果',
                children: [
                    {
                        headerName: '水果箱数',
                        field: 'FRUITSNUM01',
                        width: 10,
                        cellStyle: {
                            textAlign: 'center',
                        },
                        style: {
                            alignment: { vertical: 'bottom', horizontal: 'right' },
                        },
                    },
                    {
                        headerName: '成交额(万元)',
                        field: 'FRUITSAMT01',
                        width: 18,
                        cellStyle: {
                            textAlign: 'right',
                        },
                        style: {
                            numFmt: '0.00',
                            alignment: { vertical: 'bottom', horizontal: 'right' },
                        },
                    },
                ],
            },
            {
                headerName: '火龙果',
                children: [
                    {
                        headerName: '水果箱数',
                        field: 'FRUITSNUM02',
                        width: 10,
                        cellStyle: {
                            textAlign: 'center',
                        },
                        style: {
                            alignment: { vertical: 'bottom', horizontal: 'right' },
                        },
                    },
                    {
                        headerName: '成交额(万元)',
                        field: 'FRUITSAMT02',
                        width: 18,
                        cellStyle: {
                            textAlign: 'right',
                        },
                        style: {
                            numFmt: '0.00',
                            alignment: { vertical: 'bottom', horizontal: 'right' },
                        },
                    },
                ],
            },
            {
                headerName: '西瓜',
                children: [
                    {
                        headerName: '水果箱数',
                        field: 'FRUITSNUM03',
                        width: 10,
                        cellStyle: {
                            textAlign: 'center',
                        },
                        style: {
                            alignment: { vertical: 'bottom', horizontal: 'right' },
                        },
                    },
                    {
                        headerName: '成交额(万元)',
                        field: 'FRUITSAMT03',
                        width: 18,
                        cellStyle: {
                            textAlign: 'right',
                        },
                        style: {
                            alignment: { vertical: 'bottom', horizontal: 'right' },
                            numFmt: '0.00',
                        },
                    },
                ],
            },
            {
                headerName: '水蜜桃',
                field: 'FRUITSNUM04',
                width: 500,
                cellStyle: {
                    textAlign: 'center',
                },
                style: {
                    alignment: { vertical: 'bottom', horizontal: 'right' },
                },
            },
            {
                headerName: '合计',
                children: [
                    {
                        headerName: '水果箱数',
                        field: 'FRUITSNUM',
                        width: 10,
                        cellStyle: {
                            textAlign: 'center',
                        },
                        style: {
                            alignment: { vertical: 'bottom', horizontal: 'right' },
                        },
                    },
                    {
                        headerName: '成交额(万元)',
                        field: 'FRUITSAMT',
                        width: 18,
                        cellStyle: {
                            textAlign: 'right',
                        },

                        style: {
                            numFmt: '0.00',
                            alignment: { vertical: 'bottom', horizontal: 'right' },
                        },
                    },
                ],
            },
        ]
    }

    _onPress = (rowMergeCell) => {
        let { number, columnDefs } = this.state;
        if (number < 10) {
            WizNotice.error('由于合并demo需要，数据不能少于10条')
            return
        }
        this.setState(
            {
                spinning: true,
                spinningText: '数据处理中'
            }, () => {
                //表数据
                let dataList = [];
                for (let i = 0; i < (number > 10 ? number : 10); i++) {
                    let a = {};
                    a.FRUITSNUM01 = 2954 + i;
                    a.FRUITSNUM02 = 208 + i;
                    a.FRUITSAMT01 = '467708970.73';
                    a.FRUITSAMT02 = '1365878491.45';
                    a.FRUITSAMT03 = '12372145447.15';
                    a.FRUITSAMT04 = '444718.61';
                    a.FRUITSAMT = '14206177627.95';
                    a.FRUITS_ADMDIV_CODE = '3201';
                    a.FRUITSNUM = 6040 + i;
                    a.FRUITSNUM03 = 271 + i;
                    a.FRUITS_ADMDIV_VALUE = '南京市' + i;
                    a.FRUITSNUM04 = 2602 + i;
                    a.rowIndex = i;
                    dataList.push(a);
                }
                //总计
                const bottomData = [
                    {
                        FRUITSNUM01: 4318,
                        FRUITSAMT01: 467855313.54,
                        FRUITSNUM02: 379,
                        FRUITSAMT02: 1365889354.58,
                        FRUITSNUM03: 297,
                        FRUITSAMT03: 12372147313.47,
                        FRUITSNUM04: 2828,
                        FRUITSAMT04: 475027.29,
                        FRUITSNUM: 7827,
                        FRUITSAMT: 14206367008.89,
                        FRUITS_ADMDIV_VALUE: '总计',
                    },
                ];
                let columns = columnDefs.filter((_, index) => index)
                let rows = dataList.concat(bottomData)
                setTimeout(() => {
                    this.setState(
                        { spinning: false },
                        () => {
                            WizBrowserExport({
                                title: 'excelExportDemo',
                                sheetName: 'excelExportDemo',
                                columns: columns,
                                rows: rows,
                                filename: 'excelExportDemo.xlsx',
                                rowMergeCell
                            })
                        }
                    )
                }, 500);
            }
        )
    }

    _render() {
        const { dataSource, number, spinning, spinningText } = this.state;
        return (
            <WizLayout className="full-layout page banner-page">
                <Content>
                    <WizSpin tip={spinningText} spinning={spinning}>
                        <WizCard title={'设置导出数量'} icon='number'>
                            <span>导出数量：</span>
                            <WizInputNumber min={10} max={10000} defaultValue={10}
                                value={number}
                                onChange={(number) => { this.setState({ number }) }}
                            />
                        </WizCard>
                        <WizCard title={'导出'} icon='bar-chart'>
                            <span style={{ marginLeft: 10 }}>
                                <WizButton onClick={this._onPress} type="primary">导出</WizButton>
                            </span>
                        </WizCard>
                        <WizCard title={'行单元格合并'} icon='bar-chart'>
                            <span style={{ marginLeft: 10 }}>
                                <WizButton onClick={() => {
                                    this._onPress(['A4:B4', 'C4:D4'])
                                }} type="primary">导出</WizButton>
                            </span>
                        </WizCard>
                        <WizCard title={'列单元格合并'} icon='bar-chart'>
                            <span style={{ marginLeft: 10 }}>
                                <WizButton onClick={() => {
                                    this._onPress(['B6:B8'])
                                }} type="primary">导出</WizButton>
                            </span>
                        </WizCard>
                        <WizCard title={'跨行列单元格的合并'} icon='bar-chart'>
                            <span style={{ marginLeft: 10 }}>
                                <WizButton onClick={() => {
                                    this._onPress(['A8:B10'])
                                }} type="primary">导出</WizButton>
                            </span>
                        </WizCard>
                    </WizSpin>
                </Content>
            </WizLayout>
        );
    }
}

const mapStateToProps = (state, ownProps) => {
    return {

    };
};

export default connect(mapStateToProps)(BrowserExport);
